<template>
  <div class="main">
    <div class="logo">
      <!-- <img src="../assets/logo.png" alt="" /> -->
    </div>
    <div class="form">
      <img src="../assets/loginBg.png" alt="" />
      <!-- 表单 -->
      <div class="formData">
        <h3>欢迎登陆</h3>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="用户名" prop="name">
            <el-input v-model="ruleForm.name"></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="pass">
            <el-input
              type="password"
              v-model="ruleForm.pass"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              style="width: 100%; border-radius: 30px; margin-top: 10px"
              type="primary"
              @click="submitForm('ruleForm')"
              >立即登录</el-button
            >
          </el-form-item>
          <div class="tip">
            <router-link :to="{ path: '/register' }"
              ><span>立即注册</span></router-link
            >
            <router-link :to="{ path: '/forgotpassword' }"><span>忘记密码</span></router-link>
          </div>
        </el-form>
      </div>
    </div>
    <div class="company">
      <p>河北睿银金融服务外包有限公司</p>
      <p>版权所有 @ 河北睿银金融服务外包有限公司.冀ICP备18005534号-1</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ruleForm: {
        name: "",
        pass: "",
      },
      rules: {
        name: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        pass: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
    };
  },
  methods: {
    // 提交表单
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$message({
            message: "登录成功！",
            type: "success",
          });
          setTimeout(() => {
            this.$router.push({
              path: "/",
            });
          }, 1000);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.main {
  padding-bottom: 50px;
  background: #f2f6fc;
  .logo {
    height: 100px;
    // padding: 20px 0 20px 50px;
    // img {
    //   width: 160px;
    //   height: 60px;
    // }
  }
  .form {
    display: flex;
    width: 900px;
    margin: 0 auto;
    img {
      width: 450px;
      height: 500px;
    }
    .formData {
      flex: 1;
      background: #ffffff;
      h3 {
        padding-top: 80px;
        text-align: center;
        font-size: 30px;
        color: #515a6e;
      }

      .el-form {
        padding-right: 50px;
      }
      .tip {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        a {
          text-decoration: none;
        }
        .router-link-active {
          text-decoration: none;
        }
        span {
          font-size: 14px;
          color: #2d8cf0;
        }
        span:nth-child(1) {
          padding-left: 100px;
        }
      }
    }
  }
  .company {
    margin-top: 30px;
    text-align: center;
    font-size: 14px;
    color: #515a6e;
  }
}
</style>